import type {WootricConfig} from './wootric.types';

function parseExcludedDomains(raw: string | undefined): string[] {
    if (!raw) {
        return [];
    }
    try {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) {
            return parsed.map((domain) => String(domain).trim()).filter(Boolean);
        }
    } catch {
        // fall through to comma-separated
    }
    return raw
        .split(',')
        .map((domain) => domain.trim().replace(/^["']|["']$/g, ''))
        .filter(Boolean);
}

export function getWootricConfig(): WootricConfig {
    return {
        enabled: WOOTRIC_ENABLED,
        accountToken: WOOTRIC_ACCOUNT_TOKEN,
        productName: WOOTRIC_PRODUCT_NAME,
        productReportingCode: WOOTRIC_REPORTING_CODE,
        testMode: WOOTRIC_TEST_MODE,
        excludedDomains: parseExcludedDomains(WOOTRIC_EXCLUDED_DOMAINS),
        cdnUrl: WOOTRIC_CDN_URL
    };
}

export function isEmailExcluded(email: string, excludedDomains: string[]): boolean {
    const normalizedEmail = email.toLowerCase();
    return excludedDomains.some((domain) => normalizedEmail.includes(domain.toLowerCase()));
}
